var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{staticClass:"upper",attrs:{"value":_vm.loader}},[_c('v-img',{staticClass:"rounded-xl",style:('background-color: white'),attrs:{"src":require('@/assets/loader/Logo Loading Full Loop 150x150.gif'),"max-width":"150px","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }